module.exports = __webpack_public_path__ + "static/media/entryfy.648703b8.png";